import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepageProductItemBlockData from 'Models/Content/HomepageProductItemBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import {useInView} from 'react-intersection-observer';
import {getImageProps} from 'app/utilities/ImageProps';

const HomepageProductItemBlock = ({data, context}: ComponentProps<HomepageProductItemBlockData>) => {
  const [isIn, setIsIn] = useState(false);

  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) setIsIn(true);
  }, [inView]);

  return (
    <div ref={ref} className={`HomepageProductItemBlock`}>
      <div className={`HomepageProductItemBlock__wrap ${isIn ? 'slide-in' : ''}`}>
        {data.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
          <h2 key={i}>{getTextWithHighlight({text: text.value, highlightText: highlightText.value})}</h2>
        ))}
        <p className='HomepageProductItemBlock__subtitle'>{data.subtitle.value}</p>

        <div className='HomepageProductItemBlock__image-wraper'>
          <Image className='HomepageProductItemBlock__image-wraper__image' {...getImageProps(data.image, context)} />
        </div>

        <div className='HomepageProductItemBlock__price-and-button'>
          <div className='HomepageProductItemBlock__price-and-button__price'>
            <span className='HomepageProductItemBlock__price-and-button__price__pre-price'>{data.prePriceText.value}</span>

            <span className='HomepageProductItemBlock__price-and-button__price__fix-price'>
              {data.price.value}

              <span className='HomepageProductItemBlock__price-and-button__price__fix-price__symbol'>₪</span>
            </span>
            <span className='HomepageProductItemBlock__price-and-button__price__after-price'>{data.afterPriceText.value}</span>
          </div>

          {data.link.value && (
            <a className='HomepageProductItemBlock__price-and-button__button' href={data.link.value}>
              {data.linkTitle.value || 'לפרטים'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomepageProductItemBlock;
